if (!customElements.get("component-accordion")) {
	class Accordion extends HTMLElement {
		constructor() {
			super();

			// Cache selectors to reduce redundant DOM queries
			this.inputs = this.querySelectorAll('input[type="checkbox"]');
			this.accordionItems = this.querySelectorAll(".accordion-item");

			this.initAccordion();
			this.updateHeights();

			document.addEventListener('shopify:block:select', e => {
				if (e.target) {
					let input = e.target.querySelector('input');

					if (input) {
						input.checked = true;
						input.dispatchEvent(new Event('change'));
					}
				}
			})
		}

		initAccordion() {
			if (this.inputs.length > 0) {
				for (const input of this.inputs) {
					input.addEventListener('click', e => {
						for (const input of this.inputs) {
							if (e.target != input) {
								input.checked = false;
							}
						}
					});
				}
			}
		}

		updateHeights() {
			if (this.accordionItems.length > 0) {
				for (const li of this.accordionItems) {
					let content = li.querySelector(".content");

					if (content) {
						let innerContent = content.querySelector(".content-inner");

						if (innerContent != null) {
							let style = document.createElement("style");
							style.innerHTML = `
                #${li.id} input[type='checkbox']:checked ~ .content {
                  max-height: ${innerContent.clientHeight}px;
                }
              `;

							li.parentElement.appendChild(style);
						}
					}
				}
			}
		}
	}

	document.addEventListener("DOMContentLoaded", function () {
		customElements.define("component-accordion", Accordion);
	});
}
